'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'Which is the trusted Marathi Dhor Kakkayya Caste Vadhu Var Suchak?', answer: 'Visit MarathiVadhuVarSuchak.com Marathi matrimonial site, which is the most trusted Dhor Kakkayya Caste Vadhu Var Suchak.' },
  { question: 'How to search Dhor Kakkayya grooms and brides profiles online?', answer: 'To search Dhor Kakkayya Samaj grooms and brides profiles online, download MarathiVadhuVarSuchak.com Marathi matrimonial app for free registration.' },
  { question: 'Which is the best Dhor Kakkayya Samaj matrimonial app in Maharashtra?', answer: 'MarathiVadhuVarSuchak.com matrimonial app is the most trusted brand for Dhor Kakkayya Samaj Vadhu Var.' },
  { question: 'How to search Dhor Kakkayya Photos with profiles on Matrimony site?', answer: 'To search educated Dhor Kakkayya caste Vadhu Var profiles, register free through MarathiVadhuVarSuchak.com site.' },
  { question: 'How to search Hindu Dhor Samaj Dhor Kakkayya Photos with matrimony profiles?', answer: 'To search Dhor Kakkayya Samaj Vadhu Var profiles you need to register through MarathiVadhuVarSuchak.com mobile app.' },
  { question: 'How to do Dhor Kakkayya caste category free matrimonial site registration?', answer: 'MarathiVadhuVarSuchak.com mobile app is the most trusted option register free for Dhor Kakkayya caste category brides and grooms.' },
  { question: 'Which is the best Dhor Kakkayya Matrimony in Pune?', answer: 'For Pune-based Dhor Kakkayya Samaj Vadhu Var, MarathiVadhuVarSuchak.com mobile app is the best option for free registration.' },
  { question: 'How to do search for Dhor Kakkayya Brides in Maharashtra?', answer: 'You can search verified profiles of Dhor Kakkayya Brides in Maharashtra through MarathiVadhuVarSuchak.com Marathi matrimonial mobile app.' },
  { question: 'How to search Dhor Kakkayya brides in Mumbai?', answer: "To search Mumbai-based Dhor Kakkayya bride's profiles, visit MarathiVadhuVarSuchak.com Marathi matrimony site for free registration." },
  { question: 'Which is the best matrimony for Dhor Caste Vadhu Var?', answer: 'For Dhor Caste Vadhu Var, MarathiVadhuVarSuchak.com Marathi matrimony mobile app is the trusted brand.' },
  { question: 'How to download Dhor Samaj Vadhu Var List online?', answer: "To view Dhor Samaj Vadhu Var List online, you have register free on 'Marathi Vadhu Var Suchak' Marathi matrimony portal." },
  { question: 'How to attend Dhor Samaj Vadhu Var Melava 2026 in Maharashtra?', answer: 'MarathiVadhuVarSuchak.com organizes time-to-time Dhor Samaj Vadhu Var Melava in Maharashtra. Keep visiting our official site for latest updates.' },
  { question: 'Which is the best Dhor Samaj Vadhu Var Suchak Mandal in Maharashtra?', answer: 'From trust point of view, MarathiVadhuVarSuchak.com is the best Dhor Samaj Vadhu Var Suchak Mandal in Maharashtra state.' },
  { question: 'How to join Dhor Samaj Vadhu Var Whatsapp Group Link?', answer: 'No! MarathiVadhuVarSuchak.com does not any Whatsapp Group Link to join due to privacy policy.' },
  { question: 'How to search Dhor Samaj Vadhu list online?', answer: "To view Dhor Samaj Vadhu list online, you have to visit 'Marathi Vadhu Var Suchak' Marathi matrimonial portal." },
  { question: 'How to search Dhor Samaj Var list online?', answer: "To view Dhor Samaj Var list online, Dhor Kakkaya grooms and brides have to register free on 'Marathi Vadhu Var Suchak' Marathi matrimony site." },
  { question: 'How to search Dhor Samaj Brides online for free?', answer: 'To search Dhor Samaj Brides online for free, register on MarathiVadhuVarSuchak.com portal.' },
  { question: 'How to search the Veershaiv Kakkaya Dhor Samaj Brides online?', answer: 'To search Veershaiv Kakkaya Dhor Samaj Brides online, you have to register free through MarathiVadhuVarSuchak.com site.' },
  { question: 'Which is the No.1 Marathi Dhor Matrimony site in Maharashtra?', answer: 'In Maharashtra state, MarathiVadhuVarSuchak.com is the No.1 Marathi Dhor Matrimony site.' },
];

const communityServices: { label: string; href?: string }[] = [
  { label: "Dhor Kakkayya Caste" },
  { label: "Dhor Kakkayya" },
  { label: "Dhor Kakkayya Samaj" },
  { label: "Dhor Kakkayya Photos" },
  { label: "Hindu Dhor Samaj Dhor Kakkayya Photos" },
  { label: "Dhor Kakkayya Caste Category" },
  { label: "Dhor Kakkayya Matrimony" },
  { label: "Dhor Kakkayya Brides in Maharashtra" },
  { label: "Dhor Kakkayya brides" },
  { label: "Dhor Caste Vadhu Var" },
  { label: "Dhor Samaj Vadhu Var List" },
  { label: "Dhor Samaj Vadhu" },
  { label: "Dhor Samaj Vadhu Var Melava 2026" },
  { label: "Dhor Samaj Vadhu Var Suchak" },
  { label: "Dhor Samaj Vadhu Var Whatsapp Group Link" },
  { label: "Dhor Samaj Vadhu List" },
  { label: "Dhor Samaj Var List" },
  { label: "Dhor Samaj Brides" },
  { label: "Veershaiv Kakkaya Dhor Samaj Brides" },
  { label: "Dhor Matrimony" },
];

export default function DhorKakkayyaMatrimonyClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="ढोर कक्कय्या समाजातील वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="dhor_kakkayya_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Dhor Kakkayya Matrimony for Marathi Dhor Kakkayya Communities"
        items={communityServices}
      />

    </div>
  );
}
